import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { AddButton, DeleteButton } from '../../../Res/BaseButton';
import { uuid } from '../../../../../item/ItemTools';
import { setTD, setTH, setTDDate } from '../../../../../item/ItemTableList';
import { RespTeamHistory } from '../../../../../item/MyStat/ItemTeam';


export function TeamHistory({ title, teamId, items, action, isEdit = false }) {
  const [init, setInit] = useState(true)
  const [mItems, setItems] = useState([])
  const [team_id, set_team_id] = useState("")

  const [html, setHtml] = useState(<></>)

  useEffect(() => {
    if (items !== undefined && items.length !== 0 && items !== mItems && init) {
      // console.log(items)
      setItems(items)
      setInit(false)
    }
  }, [items])

  useEffect(()=>{
    set_team_id(teamId)
  },[teamId])

  useEffect(() => {
    if (mItems !== [] && mItems !== items) {
      action(mItems)
    }
    setItemBox(mItems)
  }, [mItems])

  function addItem() {
    console.log(mItems)
    var tItems = mItems.filter(item => {
      return item.team_history_id!==""
    })
    console.log(tItems)
    tItems.push(new RespTeamHistory({
      team_history_id: uuid(32, 64),
      team_id
    }))
    console.log(tItems)
    setItems(tItems)
  }

  function delItem(id) {
    console.log(id)
    var tItems = mItems.filter(item => {
      return item.team_history_id !== id
    })
    setItems(tItems)
  }


  function team_name_action(k, v) {
    // console.log(v)
    var [...tItems] = mItems
    for (let e of tItems) {
      if (e.team_history_id === k) e.team_name = v;
    }
    setItems(tItems)
  }

  function team_name_eng_action(k, v) {
    // console.log(v)

    var [...tItems] = mItems
    for (let e of tItems) {
      if (e.team_history_id === k) e.team_name_eng = v;
    }
    setItems(tItems)
  }

  function team_duration_start_onChange(k, v) {
    // console.log(k)
    // console.log(v)
    var [...tItems] = mItems
    try {
      for (let e of tItems) {
        if (e.team_history_id === k) {
          if(v === "Invalid date"){
            e.team_duration_start = null
          }else{
            e.team_duration_start = moment(v).format('YYYY-MM-DD');
          }
        }
      }
      setItems(tItems)
      // console.log(tItems)
    } catch (error) {
      
    }
  }
  function team_duration_end_onChange(k, v) {
    // console.log(k)
    // console.log(v)
    var [...tItems] = mItems
    try {
      for (let e of tItems) {
        if (e.team_history_id === k) {
          if(v === "Invalid date"){
            e.team_duration_end = null
          }else{
            e.team_duration_end = moment(v).format('YYYY-MM-DD');
          }
        }
      }
      setItems(tItems)
      // console.log(tItems)
    } catch (error) {
      
    }

  }

  function setItemBox(items){
      setHtml( <>
      {items.map((item, index) => (
        getItemBox(item, index)
      ))}
      </>)
  }

  function getItemBox(item, index) {
    var html =
      <tr key={index}>
        {setTD({ content: item.team_name, isEdit, id: item.team_history_id, action: team_name_action })}
        {setTD({ content: item.team_name_eng, isEdit, id: item.team_history_id, action: team_name_eng_action })}
        {setTDDate({ content: item.team_duration_start, isEdit, id: item.team_history_id, action: team_duration_start_onChange })}
        {setTDDate({ content: item.team_duration_end, isEdit, id: item.team_history_id, action: team_duration_end_onChange })}

        {isEdit ?
          <td className="text-center"><DeleteButton action={delItem} id={item.team_history_id} /></td>
          : <></>
        }
      </tr>
    return html
  }
  

  return (
    <>
      <div className="panel panel-default">
        <div className="panel-heading">
          <div className="row">
            <div className="col-sm-4">
              <h3>{title}</h3>請依時間先後建立(新 &rarr; 舊)
            </div>
            <div className="col-sm-8">
              <div className="row text-right">
                {isEdit ?
                  <AddButton action={addItem} />
                  : <></>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="panel-body">
          <div className="row">
            <div className="col-lg-12">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    {setTH({ name: "中文名稱", size: 3 })}
                    {setTH({ name: "英文名稱", size: 3 })}
                    {setTH({ name: "適用起始", size: 2 })}
                    {setTH({ name: "適用結束", size: 2 })}
                    {isEdit ?
                      setTH({ name: "功能", size: 1 })
                      : <></>
                    }
                  </tr>
                </thead>
                <tbody>
                  {html}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}